<template>
	<div id="navigation">
		<nav class="navbar is-spaced is-transparent">
			<div class="container">
				<div class="navbar-brand">
					<div class="navbar-item">
						<router-link to="/">
							<img src="@/assets/logo/navlogo.png" width="112" height="28" />
						</router-link>
					</div>

					<a role="button" class="navbar-burger burger" @click="navigation()">
						<span aria-hidden="true"></span>
						<span aria-hidden="true"></span>
						<span aria-hidden="true"></span>
					</a>
				</div>

				<div class="navbar-menu" :class="{ 'is-active': active }">
					<div class="navbar-start">
                        <router-link class="navbar-item has-text-white" to="/"
							>Home</router-link
						>
						<router-link class="navbar-item has-text-white" to="/about"
							>About</router-link
						>
						<router-link class="navbar-item has-text-white" to="/programs"
							>Programs</router-link
						>
						<router-link class="navbar-item has-text-white" to="/articles"
							>Articles</router-link
						>
						<router-link class="navbar-item has-text-white" to="/contact"
							>Contact</router-link
						>
                    </div>

					<div class="navbar-end">
						<div class="navbar-item is-hidden-touch">
							<a class="button is-wide is-primary is-outlined thick is-rounded" style="font-weight: 700; color: white"
                            href="https://fitcowellness.us.auth0.com/authorize?response_type=token&client_id=nS2ci9adEpHmOoIKUomVWVzKMBhHygYe&redirect_uri=https://my.fitcowellness.com/">Login</a>
						</div>
					</div>
				</div>
			</div>
		</nav>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			active: false,
		};
	},
	methods: {
		navigation: function () {
			this.active = !this.active;
		},
	},
};
</script>

<style>
.navbar-item {
	font-weight: 700;
	margin-left: 10px;
	margin-right: 10px;
}

.navbar-burger span {
	background-color: white;
}

.navbar-start{
    flex-grow: 1;
    justify-content: center;
}

@media screen and (min-width: 1024px) {
	.navbar-item:not(div)::before {
		content: "";
		position: absolute;
		width: 80%;
		height: 2px;
		bottom: 0;
		left: 10%;
		background-color: #f2f0f1;
		visibility: hidden;
		transform: scaleX(0);
		transition: all 0.3s ease-in-out 0s;
	}
	.navbar-item:not(div):hover::before {
		visibility: visible;
		transform: scaleX(1);
	}
}

@media screen and (max-width: 768px) {
	.navbar-menu {
		background-color: #070a0a;
	}
}
</style>